(() => {
  const initSection = (root) => {
    if (!root || root.dataset.ttlInitialized === 'true') return;
    root.dataset.ttlInitialized = 'true';

    const formSection = root.querySelector('[data-ttl-form-section]');
    const form = root.querySelector('form.ttl-b2b__form');
    const tierSelect = root.querySelector('[data-ttl-tier-select]');
    const sticky = root.querySelector('[data-ttl-sticky]');

    const scrollToForm = () => {
      if (!formSection) return;
      formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => {
        const firstInput = formSection.querySelector('input:not([type="hidden"]), select, textarea');
        if (firstInput) firstInput.focus({ preventScroll: true });
      }, 650);
    };

    root.querySelectorAll('[data-ttl-scroll-form]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const requestedTier = button.getAttribute('data-tier');
        if (requestedTier) {
          const formTier = root.querySelector('[data-ttl-form-tier]');
          if (formTier) formTier.value = requestedTier;
          if (tierSelect) {
            tierSelect.value = requestedTier;
            tierSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        scrollToForm();
      });
    });

    const formatCurrency = (value) => {
      try {
        return new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
      } catch (error) {
        return `${Number(value).toFixed(2).replace('.', ',')} €`;
      }
    };

    const updateCalculator = () => {
      if (!tierSelect) return;
      const option = tierSelect.options[tierSelect.selectedIndex];
      const quantity = Number(option.dataset.quantity || option.value || 0);
      const wholesale = Number(option.dataset.wholesale || 0);
      const retail = Number(root.dataset.retailUnit || 0);
      const retailCure = Number(root.dataset.retailCure || 0);

      const investment = quantity * wholesale;
      const projectedRevenue = quantity * retail;
      const grossMargin = projectedRevenue - investment;
      const unitMargin = retail - wholesale;
      const cureMargin = retailCure - wholesale * 3;

      const values = {
        '[data-ttl-calc-investment]': investment,
        '[data-ttl-calc-revenue]': projectedRevenue,
        '[data-ttl-calc-unit-margin]': unitMargin,
        '[data-ttl-calc-cure-margin]': cureMargin,
        '[data-ttl-calc-margin]': grossMargin,
      };

      Object.entries(values).forEach(([selector, value]) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = formatCurrency(value);
      });
    };

    if (tierSelect) {
      tierSelect.addEventListener('change', updateCalculator);
      updateCalculator();
    }

    if (form) {
      const params = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'].forEach((key) => {
        const value = params.get(key);
        if (!value) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `contact[${key}]`;
        input.value = value;
        form.appendChild(input);
      });

      const pageInput = document.createElement('input');
      pageInput.type = 'hidden';
      pageInput.name = 'contact[Page source]';
      pageInput.value = window.location.href;
      form.appendChild(pageInput);
    }

    if (sticky && formSection && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => sticky.classList.toggle('is-hidden', entry.isIntersecting));
        },
        { threshold: 0.15 }
      );
      stickyObserver.observe(formSection);
    }

    const revealNodes = root.querySelectorAll('[data-ttl-reveal]');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px' }
      );
      revealNodes.forEach((node) => revealObserver.observe(node));
    } else {
      revealNodes.forEach((node) => node.classList.add('is-visible'));
    }

    const success = root.querySelector('[data-ttl-form-success]');
    if (success && formSection) {
      window.setTimeout(() => formSection.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-ttl-b2b]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
